<template>
  <div class="flex flex-col items-center">
    <section class="p-6 flex flex-col items-center gap-8 w-full max-w-[375px] m-5">
      <img :src="logo" width="160" alt="logo"/>

      <div class="flex flex-col gap-3 w-full" @keyup.enter="recaptcha">
        <rpm-input
          class="w-full"
          placeholder="Usuário"
          v-model="loginForm.username"
          :errors="errors.username"
          required
        ></rpm-input>

        <rpm-input
          class="w-full"
          type="password"
          placeholder="Senha"
          v-model="loginForm.password"
          :errors="errors.password"
          required
        ></rpm-input>

        <rpm-input
          class="w-full"
          type="checkbox"
          core-class="flex flex-row gap-2 items-center"
          post="Manter conectado"
          post-class="text-xxs text-default/80 dark:text-white/80 font-bold"
          v-model="loginForm.remember"
        ></rpm-input>
      </div>

      <rpm-button
        class="w-full"
        label="Login"
        :loading="loading"
        @click.prevent="recaptcha"
      ></rpm-button>
    </section>

    <footer class="fixed bottom-0 pb-8 flex flex-wrap justify-center gap-x-6 gap-y-2 text-center text-[10px] font-medium text-default/60 dark:text-white/60">
      <a href="https://ae3tecnologia.com.br/legal/politica-de-cookies" target="_blank" class="hover:text-blue-500 underline underline-offset-2">
        Política de Cookies
      </a>
      <a href="https://ae3tecnologia.com.br/legal/politica-de-privacidade" target="_blank" class="hover:text-blue-500 underline underline-offset-2">
        Política de Privacidade
      </a>
      <a href="https://ae3tecnologia.com.br/legal/termos-de-uso" target="_blank" class="hover:text-blue-500 underline underline-offset-2">
        Termos de Uso
      </a>
    </footer>
  </div>
</template>

<script>

import logo from "@/src/assets/img/portal156.png";
import {useReCaptcha} from 'vue-recaptcha-v3';
import {useStore} from "vuex";
import {ref} from "vue";

export default {
  name: "Login",
  data() {
    return {
      logo
    }
  },
  setup(){
    const store  = useStore();
    const captcha = useReCaptcha();

    const errors = ref({});
    const loginForm = ref({});
    const loading = ref(false);

    const resetForm = () => {
      loginForm.value = {}
    }

    const login = () => {
      loading.value = true;
      store.dispatch("signIn", loginForm.value).then(() => {
        resetForm();
      }).catch((response) => {
        errors.value = response;
        resetForm();
      }).finally(() => {
        loading.value = false;
      });
    }

    const recaptcha = async () => {
      if (captcha?.executeRecaptcha) {
        await captcha.recaptchaLoaded();
        await captcha.executeRecaptcha('login');
      }
      login();
    }

    return {
      errors,
      loginForm,
      loading,
      login,
      recaptcha
    }
  },
};
</script>
